<template>
    <div>
        <template v-if="isPrevisit">
            <link
                :href="`/view/surveyjs/defaultV2.min.css?v=${SURVEYJS_VERSION}`"
                rel="stylesheet"
                type="text/css"
                media="all"
            />
        </template>
        <div v-if="isLoading">
            <div class="m-4 h-100 skeleton">
                <div class="row">
                    <div class="content col">
                        <div></div>
                        <div class="smaller"></div>
                    </div>
                </div>
                <div class="row">
                    <div class="content col">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </div>
        </div>
        <Survey
            v-else-if="survey"
            id="surveyjs"
            class="h-100 surveyjs"
            :survey="survey"
        />
    </div>
</template>
<script>
import { Survey, Model } from "survey-vue";
import TemplateService from "@/services/templates";
import { Converter } from "showdown";
const SURVEYJS_VERSION = "1.9.130";

var converter = new Converter();

const FALLBACK_MB = 100;
const FALLBACK_MAX = FALLBACK_MB * 1024 * 1024; // bytes

export default {
    props: {
        webform: {
            type: Object,
            default() {}
        },
        isPrevisit: {
            type: Boolean,
            default: true
        }
    },
    mounted() {
        this.fetchData();
    },
    components: { Survey },
    computed: {},
    data() {
        return {
            SURVEYJS_VERSION,
            survey: null,
            isLoading: false,
            FALLBACK_MAX
        };
    },
    watch: {},
    methods: {
        async fetchData() {
            let self = this;
            self.survey = null;
            try {
                self.updateIsLoading(true);

                let response = null;
                if (self.isPrevisit) {
                    // For previsit
                    response = await TemplateService.get(
                        self.webform.id,
                        false
                    );
                } else {
                    // For Check-in
                    response = self.webform; // Use the data from API in checkin-webforms
                }
                if (response) {
                    self.survey = new Model(response.webform_content);
                    self.survey.showCompletedPage = false; // To prevent the completed page open upon hit submit button
                    self.survey.showNavigationButtons = false; // To hide the previous, next and complete button and use the external button instead
                    self.survey.onTextMarkdown.add(self.doMarkdown);
                    self.survey.onComplete.add(self.surveyOnComplete);
                    self.survey.onNavigateToUrl.add(self.onNavigateToUrl);
                    this.applyFallbackMaxSize(self.survey);

                    self.updateCurrentWebformPage(
                        self.survey,
                        self.survey.activePage
                    );
                    self.survey.onCurrentPageChanged.add((survey, option) => {
                        self.updateCurrentWebformPage(
                            survey,
                            option.newCurrentPage
                        );
                    });

                    if (
                        response.is_checkin &&
                        response.isactive &&
                        response.submitted_at
                    ) {
                        // Webform been submitted
                        // then only can view only and add info alert informing the user, this form has been submitted
                        self.survey.firstPageIsStarted = false; // Disable the first page is started to viewed the page in display mode
                        self.survey.currentPageNo = 0; // to reset the first page viewed (necessary if set first page is started and timer)
                        self.survey.data = response.webform_answers;
                        self.survey.mode = "display";

                        self.survey.onAfterRenderSurvey.add(
                            (survey, options) => {
                                // Adding the alert info in the survey body
                                const alertHtml = `<b-alert show variant="warning" class="alert alert-info font-weight-bold alert-margin" >
                                    This form has been submitted.
                                </b-alert>`;
                                this.$nextTick(() => {
                                    const surveyBody = $("#surveyjs .sd-body");
                                    surveyBody.prepend(alertHtml);
                                });
                            }
                        );
                    }
                } else {
                    // Api not retrieve the webform due to : ID not found, deleted, error on API
                    throw new Error(
                        `Form unavailable. ${
                            self.isPrevisit ? "Click next" : ""
                        }`
                    );
                }
            } catch (e) {
                console.error(e);
            } finally {
                self.updateIsLoading(false);
            }
        },
        /**
         * @method updateIsLoading
         * @description to update the loading state to the parent
         * previously we use isLoading = true and trigger the event from watch isLoading() but somehow the change that removed the axios checkin (api get online-webform), the watch not been triggered anymore
         * @param {*} val
         */
        updateIsLoading(val) {
            this.isLoading = val;
            this.$emit("isLoading", val);
        },
        /**
         * @method updateCurrentWebformPage
         * @description to send the current page state to the outside of form to handle button previos, next and submit
         * Cannot use this.$refs.webform.survey.isLastPage and etc from the parent page as has the survey will return data from previous webform
         * @param {*} survey
         * @param {*} page
         */
        updateCurrentWebformPage(survey, page) {
            this.$emit("show-previous-webform", survey.isShowPrevButton); // for previsit
            this.$emit("updateCurrentWebformPage", {
                isShowNextButton: survey.isShowNextButton,
                isShowPrevButton: survey.isShowPrevButton,
                isLastPage: survey.isLastPage,
                isStartPage: page.isStartPage,
                pageNextText: survey.pageNextText,
                pagePrevText: survey.pagePrevText,
                startSurveyText: survey.startSurveyText
            });
        },
        onNavigateToUrl(sender, options) {
            options.allow = false;
        },
        surveyOnComplete(sender, options) {
            this.$emit("webform-completed", {
                webformContent: sender.toJSON(),
                webformAnswer: sender.data,
                navigateToUrl: sender.navigateToUrl
            });
        },
        async nextPage() {
            const isPageValid = await this.survey.validateCurrentPage();
            if (this.survey.pageCount == 0) {
                // Template form empty
                this.$emit("trigger-next-doc");
            } else if (isPageValid && this.survey.isLastPage) {
                this.survey.completeLastPage();
            } else if (isPageValid) {
                if (this.survey.activePage.isStartPage) {
                    this.survey.start();
                } else {
                    this.survey.nextPage();
                }
            }
        },
        async prevPage() {
            this.survey.prevPage();
        },
        doMarkdown(survey, options) {
            //convert the markdown text to html

            var str = converter.makeHtml(options.text);
            if (str.indexOf("<p>") == 0) {
                //remove root paragraphs <p></p>
                str = str.substring(3);
                str = str.substring(0, str.length - 4);
            }
            //set html
            options.html = str;
        },
        applyFallbackMaxSize(survey) {
            survey.getAllQuestions().forEach(q => {
                if (
                    q.getType?.() === "file" &&
                    (!q.maxSize || q.maxSize === 0)
                ) {
                    q.maxSize = this.FALLBACK_MAX;
                }
            });
        }
    }
};
</script>
<style lang="scss">
.surveyjs {
    input {
        height: initial;
    }
    .sd-tagbox__filter-string-input,
    .sd-dropdown__filter-string-input {
        -webkit-appearance: initial;
        background: initial;
        padding: initial;
        border-radius: initial;
        border: initial;
    }

    table th {
        background: initial;
    }
    p,
    ul,
    ol,
    pre,
    table,
    blockquote {
        margin-bottom: initial;
    }
}
@import "@/scss/webform.scss";
.skeleton {
    .image {
        padding: 1em;

        div {
            background-color: #f6f6f6;
            height: 10em;
            animation-duration: 10s;
            animation-fill-mode: forwards;
            animation-iteration-count: infinite;
            animation-name: loading;
            animation-timing-function: linear;
            background: #f6f7f8;
            background: linear-gradient(
                to right,
                #f6f6f6 8%,
                #eeeeee 30%,
                #f6f6f6 33%
            );
        }
    }

    .content {
        padding: 1em;

        div {
            margin-bottom: 1em;
            height: 2em;
            animation-duration: 10s;
            animation-fill-mode: forwards;
            animation-iteration-count: infinite;
            animation-name: loading;
            animation-timing-function: linear;
            background: #f6f7f8;
            background: linear-gradient(
                to right,
                #f6f6f6 8%,
                #eeeeee 30%,
                #f6f6f6 33%
            );

            &.smaller {
                height: 2em;
                width: 60%;
            }
        }
    }
}

@media (min-width: 768px) {
    .alert-margin {
        margin-left: 40px;
        margin-right: 40px;
    }
}
</style>
